const translations = {
  // Navbar
  "nav.pricing": "Pricing",
  "nav.features": "How It Works",
  "nav.support": "Support",
  "nav.contact": "Contact",

  // Hero
  "hero.badge": "Satisfaction guaranteed or money back",
  "hero.title1": "Your unlimited home",
  "hero.title2": "cinema TV!",
  "hero.desc": "Enjoy unlimited access to <b>+35,000 live channels</b> and <b>+70,000 movies & series</b> in HD/4K quality — <b>0 cuts, 0 freezes</b>. Our team is available <b>7 days/7 from 10am to 11pm</b>. Try for free and join thousands of satisfied customers!",
  "hero.cta_primary": "Try Now",
  "hero.cta_secondary": "Contact Us",
  "hero.rating_text": "– +2,300 clients",
  "hero.feature_trial": "Free 24h Trial",
  "hero.feature_channels": "+35,000 Channels",
  "hero.feature_vod": "Movies & Series 4K",
  "hero.feature_stable": "Stable Service 24/7",
  "hero.discover": "🔥 Discover Our Offers",

  // Social Proof
  "social.badge": "Payment Proofs",
  "social.title1": "+10,000 Satisfied",
  "social.title2": "Clients",
  "social.desc": "Real proofs from our clients — verified payments and subscriptions activated live",
  "social.stat1_val": "10,000+",
  "social.stat1_label": "Satisfied Clients",
  "social.stat2_val": "4.9/5",
  "social.stat2_label": "Average Rating",
  "social.stat3_val": "98%",
  "social.stat3_label": "Satisfaction Rate",

  // Pricing
  "pricing.badge": "💎 Exclusive Offers",
  "pricing.title": "Premium Streaming Subscription",
  "pricing.subtitle": "🎥 Unlimited access to +40,000 Movies & Series + 35,000 live TV channels — Guaranteed 4K quality without interruption!",
  "pricing.premium_badge": "PREMIUM",
  "pricing.premium_title": "Premium Offer",
  "pricing.premium_sub": "The essentials of quality streaming",
  "pricing.gold_badge": "PREMIUM GOLD",
  "pricing.gold_title": "Premium",
  "pricing.gold_title2": "GOLD",
  "pricing.gold_sub": "The ultimate streaming experience • All included",
  "pricing.gold_desc1": "Enjoy unlimited access to more than <b>35,000 live channels</b> and more than <b>70,000 movies and series</b>",
  "pricing.recommended": "RECOMMENDED",
  "pricing.months3": "3 Months",
  "pricing.months6": "6 Months",
  "pricing.months12": "12 Months",
  "pricing.months1": "1 Month",
  "pricing.per_month1": "79 MAD/month",
  "pricing.per_month3": "50 MAD/month",
  "pricing.per_month6": "33 MAD/month",
  "pricing.per_month12": "25 MAD/month",
  "pricing.per_month1g": "99 MAD/month",
  "pricing.per_month3g": "66 MAD/month",
  "pricing.per_month6g": "50 MAD/month",
  "pricing.per_month12g": "42 MAD/month",
  "pricing.bonus": "🎁 2nd sub at 45 USD",
  "pricing.replay": "Replay 24h",
  "pricing.btn_test": "🎁 Test",
  "pricing.btn_choose": "🔥 Choose",
  "pricing.card_discount": "💳 -10% discount when paying by credit card",
  "pricing.payment_title": "Accepted payment methods",
  "pricing.secure": "Secure Payment",
  "pricing.instant": "Instant Activation",
  "pricing.dedicated": "Dedicated Support",
  "pricing.premium_compare": "Premium: 1 App",
  "pricing.gold_compare": "Gold: 3 Apps on the same device",

  // Premium features
  "pricing.f1": "HD/4K quality on all your screens",
  "pricing.f2": "1 IPTV Application included",
  "pricing.f3": "1 device connected simultaneously",
  "pricing.f4": "Immediate activation in 5 min",
  "pricing.f5": "WhatsApp support 7 days/7",
  "pricing.f6": "Compatible Smart TV, Box, Mobile, PC",
  "pricing.f7": "Automatic updates",
  "pricing.f8": "International channels included",
  // Gold features
  "pricing.gf1": "4K Ultra HD premium quality",
  "pricing.gf2": "3 IPTV Applications included",
  "pricing.gf3": "1 device connected simultaneously",
  "pricing.gf4": "Exclusive Anti-Freeze technology",
  "pricing.gf5": "24h Replay on select channels",
  "pricing.gf6": "Complete EPG electronic guide",
  "pricing.gf7": "24/7 priority support",
  "pricing.gf8": "Compatible with all devices",
  "pricing.gf9": "Automatic updates",
  "pricing.gf10": "Premium international content",
  "pricing.gf11": "VOD Netflix, Prime, Disney+…",
  "pricing.gf12": "Immediate activation in 5 min",

  // Stats
  "pricing.s1_val": "+25,000", "pricing.s1_sub": "HD/4K Channels",
  "pricing.s2_val": "+35,000", "pricing.s2_sub": "Movies & Series",
  "pricing.s3_val": "1 App", "pricing.s3_sub": "Included",
  "pricing.s4_val": "Stable", "pricing.s4_sub": "Connection",
  "pricing.gs1_val": "+35,000", "pricing.gs1_sub": "4K Channels",
  "pricing.gs2_val": "+70,000", "pricing.gs2_sub": "Movies & Series",
  "pricing.gs3_val": "3 Apps", "pricing.gs3_sub": "On 1 device",
  "pricing.gs4_val": "Anti-Freeze", "pricing.gs4_sub": "Technology",

  // Why Choose Us
  "why.badge": "WHY US AND NOT OTHERS",
  "why.title": "Why Choose Us!",
  "why.desc": "7 years of experience in premium streaming with thousands of satisfied customers",
  "why.exp": "EXPERIENCE OF",
  "why.exp_val": "7 Years",
  "why.b1_title": "Satisfaction Guaranteed or Refunded",
  "why.b1_desc": "If you are not fully satisfied the first week, we will refund you in full — no questions asked. Your satisfaction is our priority.",
  "why.b2_title": "Instant Activation",
  "why.b2_desc": "Once registered, you get instant access with your login credentials. Start watching immediately.",
  "why.b3_title": "Best Prices on the Market",
  "why.b3_desc": "You won't find a better value for money with such quality standards. Unbeatable prices.",
  "why.b4_title": "Top Channels & VoD",
  "why.b4_desc": "Our VoD service gives you access to the latest movies and series. Live channels and pay-per-view available.",
  "why.b5_title": "24/7 Customer Support",
  "why.b5_desc": "We are available 24 hours a day. Whether day or night, our team is ready to help you. Contact us at any time.",

  // Devices
  "devices.badge": "📺 Compatibility",
  "devices.title1": "Compatible with",
  "devices.title2": "all your devices",
  "devices.desc": "Install in less than 2 minutes on any device and enjoy streaming anywhere.",
  "devices.note": "✅ Installation guided by our technical team • ✅ Remote assistance available",
  "devices.d1": "Smart TV", "devices.d1s": "Samsung, LG, Sony, Philips…",
  "devices.d2": "Android TV", "devices.d2s": "Android Box, Nvidia Shield…",
  "devices.d3": "Fire Stick", "devices.d3s": "Amazon Fire TV Stick 4K",
  "devices.d4": "Smartphone", "devices.d4s": "iOS & Android",
  "devices.d5": "Tablet", "devices.d5s": "iPad, Samsung Tab…",
  "devices.d6": "Computer", "devices.d6s": "Windows, Mac, Linux",

  // Content
  "content.title": "Sports, Movies, Series & more",
  "content.desc": "A complete catalogue for the whole family — from live sport to unlimited entertainment.",
  "content.brands_title": "Discover a world of endless entertainment with 4K Dream",
  "content.brands_desc": "Buy one subscription and stop wasting money on multiple subscriptions. We offer the full range of content, movies and TV series, all under one virtual roof: 4K Dream",
  "content.premium_title": "Premium Entertainment Content",
  "content.sports_title": "Sports & International Leagues",
  "content.movies_title": "Popular Movies & Series",
  "content.c1_title": "⚽ Live Sports",
  "content.c1_desc": "All football, tennis, boxing, F1 — BeIN, Canal+, DAZN and more.",
  "content.c2_title": "🎬 Movies & Cinema",
  "content.c2_desc": "Thousands of films in 4K — blockbusters, classics, and new releases every week.",
  "content.c3_title": "📺 Series & VOD",
  "content.c3_desc": "Netflix, Disney+, Prime Video and more — all your favourite series in one place.",
  "content.c4_title": "🌍 International Channels",
  "content.c4_desc": "More than 150 countries covered — Arabic, European, African, American channels.",
  "content.c5_title": "👶 Kids Content",
  "content.c5_desc": "Hundreds of channels and cartoons for your children — in complete safety.",

  // Guarantee
  "guarantee.title": "Satisfaction",
  "guarantee.title2": "Guaranteed or Refunded",
  "guarantee.desc": "Test our service for <b>7 days</b>. If you are not satisfied, we will give you a full refund — no questions asked.",
  "guarantee.g1_title": "100% Refund",
  "guarantee.g1_desc": "Full refund if the service does not suit you",
  "guarantee.g2_title": "7 Days to Test",
  "guarantee.g2_desc": "A full week to discover all features",
  "guarantee.g3_title": "Dedicated Support",
  "guarantee.g3_desc": "Our team accompanies you throughout your trial",

  // Why Digicode
  "whydigi.title": "Why Choose 4K Dream?",
  "whydigi.desc": "Discover all the advantages that make us the leader of IPTV streaming",
  "whydigi.f1_title": "Satisfaction Guarantee or Refund",
  "whydigi.f1_desc": "7 days to test, full refund if not satisfied",
  "whydigi.f2_title": "Instant Activation",
  "whydigi.f2_desc": "Receive your access in less than 5 minutes after payment",
  "whydigi.f3_title": "VIP Support 7 days/7",
  "whydigi.f3_desc": "Technical assistance available from 10am to 11pm every day",
  "whydigi.f4_title": "7-Day Replay",
  "whydigi.f4_desc": "Rewatch your shows from the last 7 days whenever you want",
  "whydigi.f5_title": "Automatic Updates",
  "whydigi.f5_desc": "New channels and content added regularly",
  "whydigi.f6_title": "Anti-Freeze Technology",
  "whydigi.f6_desc": "Optimised servers for seamless streaming",
  "whydigi.f7_title": "4K Ultra HD Quality",
  "whydigi.f7_desc": "Crystal clear image on all your favourite channels",

  // World
  "world.badge": "International Coverage",
  "world.title1": "TV Streaming",
  "world.title2": "Everywhere in the World",
  "world.desc": "No matter where you are, our service is available internationally.",

  // Free Trial
  "trial.title": "Free 24h Trial",
  "trial.desc": "Test our service for 24 hours totally free.\u00a0No commitment, no credit card required.",
  "trial.form_title": "Direct WhatsApp Contact",
  "trial.success_title": "Request sent!",
  "trial.success_desc": "We will contact you very soon on WhatsApp.",
  "trial.name_label": "Full name",
  "trial.name_placeholder": "Your full name",
  "trial.phone_label": "Phone number",
  "trial.phone_placeholder": "Your phone number",
  "trial.city_label": "City",
  "trial.city_placeholder": "Your city",
  "trial.submit": "Get the Trial via WhatsApp",
  "trial.sending": "Sending...",
  "trial.h1": "24 Full Hours",
  "trial.h1d": "Unlimited access for 24 hours to all our services",
  "trial.h2": "No Commitment",
  "trial.h2d": "No credit card required, automatic cancellation",
  "trial.h3": "Instant Activation",
  "trial.h3d": "Receive your login details by email in less than 5 minutes",
  "trial.what_title": "What you can test:",
  "trial.w1": "All bouquets\nCanal+, OCS, Paramount+, Sport...",
  "trial.w2": "Full Library\n20,000+ movies and series",
  "trial.w3": "Premium Quality\n4K, Full HD quality",

  // FAQ
  "faq.badge": "FAQ",
  "faq.title1": "Frequently Asked",
  "faq.title2": "Questions",
  "faq.desc": "Everything you need to know before subscribing",
  "faq.more": "Do you have other questions?",
  "faq.cta": "Contact us on WhatsApp",
  "faq.q1": "How does your streaming service work?",
  "faq.a1": "Our IPTV service lets you watch +35,000 live channels and +70,000 movies & series via internet on all your devices. After payment, you receive your credentials in 5 minutes.",
  "faq.q2": "Which devices can I use the service on?",
  "faq.a2": "Compatible with Smart TV (Samsung, LG, Sony), Android TV, Fire Stick, iOS & Android smartphones, tablets, and Windows/Mac/Linux computers.",
  "faq.q3": "What internet speed is required?",
  "faq.a3": "Minimum 10 Mbps for HD, 25 Mbps for 4K. A fibre or 4G/5G connection is recommended.",
  "faq.q4": "How does the free 24h trial work?",
  "faq.a4": "Fill in the form above. We send you your test credentials via WhatsApp in less than 5 minutes, no credit card required.",
  "faq.q5": "Is the service reliable? Are there any interruptions?",
  "faq.a5": "Our servers use Anti-Freeze technology with 99.9% uptime. We have redundant servers to guarantee stable streaming.",
  "faq.q6": "What payment methods do you accept?",
  "faq.a6": "Visa/Mastercard (-10%), bank transfer, Wafacash, CashPlus, PayPal, Remitly, Western Union, Binance and European account.",
  "faq.q7": "How long does activation take?",
  "faq.a7": "Immediate activation in less than 5 minutes after payment confirmation, 7 days/7 from 10am to 11pm.",
  "faq.q8": "Can I use the service abroad?",
  "faq.a8": "Yes, the service works worldwide: Europe, Africa, America, Middle East. Wherever you are, access is guaranteed.",

  // Support
  "support.title": "24/7 Customer Support",
  "support.desc": "A dedicated team to accompany you at every step of your digital experience",
  "support.channels_title": "Contact Us Through Your Preferred Channel",
  "support.cta_whatsapp": "Contact Support",
  "support.note": "💬 WhatsApp • 📞 Phone • 📧 Email • 🏠 Home",
  "support.s1_title": "WhatsApp",
  "support.s1_desc": "Instant support via WhatsApp",
  "support.s1_speed": "< 5 min",
  "support.s1_hours": "24/7",
  "support.s2_title": "Phone",
  "support.s2_desc": "Direct phone assistance",
  "support.s2_speed": "Immediate",
  "support.s2_hours": "8am-11pm",
  "support.s3_title": "Email",
  "support.s3_desc": "Technical support by email",
  "support.s3_speed": "< 2h",
  "support.s3_hours": "24/7",
  "support.s4_title": "Home Visit",
  "support.s4_desc": "Technical intervention at your home",
  "support.s4_speed": "24-48h",
  "support.s4_hours": "Mon-Sat",
  "support.s4_contact": "By appointment",

  // CTA
  "cta.title": "Start Watching Today",
  "cta.desc": "Join thousands of satisfied customers. Activate your subscription in 5 minutes and enjoy +25,000 channels.",
  "cta.expires": "Promotional offer expires in",
  "cta.btn1": "Try Now",
  "cta.btn2": "Free 24h Trial",
  "cta.note": "✅ Secure payment • ✅ Instant activation • ✅ 7-day guarantee",

  // Footer
  "footer.services": "Services",
  "footer.contact": "Contact",
  "footer.coverage": "Coverage",
  "footer.legal": "Legal",
  "footer.copyright": "© 2024 4K Dream - All rights reserved.",
  "footer.s1": "Premium Subscriptions",
  "footer.s2": "Movies & Series 4K",
  "footer.s3": "Live Sport",
  "footer.s4": "24/7 Support",
  "footer.cov1": "🌍 Europe",
  "footer.cov2": "🌍 America",
  "footer.cov3": "🌍 Africa",
  "footer.cov4": "🌍 Worldwide",
  "footer.l1": "About",
  "footer.l2": "Terms & Conditions",
  "footer.l3": "Privacy Policy",
  "footer.l4": "Refund Policy",
  "footer.l5": "Contact",
};

export default translations;
